import React from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import AnimatedLogo from './AnimatedLogo';
import './LandingPage.css';

const { Title } = Typography;

const LandingPage = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/sign-in');
    };

    return (
        <div className="landing-container" onClick={handleClick}>
            <div className="landing-content">
                <AnimatedLogo width={400} height={520} />
                <Title level={1} className="landing-title">
                    pxlplygrnd
                </Title>
            </div>
        </div>
    );
};

export default LandingPage;
